const parseJsonSafe = (value, fallback = {}) => {
  if (typeof value !== "string") {
    return fallback;
  }

  try {
    return JSON.parse(value);
  } catch {
    return fallback;
  }
};

const mapServiceLocation = (serviceLocation = {}) => ({
  Id: serviceLocation.id,
  OrgId: serviceLocation.org_id,
  LocationKey: serviceLocation.location_key,
  CreatedDate: serviceLocation.created_date,
});

const mapOrganization = (organization = {}) => ({
  Id: organization.id,
  OrganizationId: organization.id,
  OrganizationName: organization.name || "",
  Subdomain: organization.subdomain || "",
  ProfileFullImage: organization.profile_image || "",
  OrgTimeZoneTz: organization.time_zone_tz || organization.time_zone || "",
  Address1: organization.address_line1 || organization.address1 || "",
  Address2: organization.address_line2 || organization.address2 || "",
  City: organization.city || "",
  County: organization.county || "",
  State: organization.state || "",
  Zip: organization.zip || organization.postal_code || "",
  DisplayCountry: organization.country || organization.country_name || "",
  Phone: organization.phone || "",
  Fax: organization.fax || "",
  NotesHours: organization.notes_hours ?? organization.notesHours ?? null,
  NotesMinute: organization.notes_minute ?? organization.notesMinute ?? null,
  Settings: parseJsonSafe(organization.settings, {}),
  IsProfileComplete:
    organization.is_profile_complete ?? organization.IsProfileComplete ?? false,
  BusinessType: organization.business_type || "",
});

export const mapOrganizationUpdateResponse = (organization = {}) => ({
  Address1: organization.address_line1 || organization.address1 || "",
  Address2: organization.address_line2 || organization.address2 || "",
  OrganizationId: organization.id,
  OrganizationName: organization.name || "",
  Subdomain: organization.subdomain || "",
  Id: organization.id,
  OrgTimeZoneTz: organization.time_zone_tz || organization.time_zone || "",
  City: organization.city || "",
  County: organization.county || "",
  State: organization.state || "",
  Zip: organization.zip || organization.postal_code || "",
  DisplayCountry: organization.country || organization.country_name || "",
  Phone: organization.phone || "",
  Fax: organization.fax || "",
});

export const mapOrgProfileResponse = (response = {}) => {
  let organization = {};
  let ServiceLocations = [];
  let OrgSkillsList = [];

  // Handle the new API response format with separate arrays
  if (
    response.organizations &&
    Array.isArray(response.organizations) &&
    response.organizations.length > 0
  ) {
    organization = mapOrganization(response.organizations[0]);
  }

  if (response.service_locations && Array.isArray(response.service_locations)) {
    ServiceLocations = response.service_locations.map(mapServiceLocation);
  }

  if (response.skill_sets && Array.isArray(response.skill_sets)) {
    OrgSkillsList = response.skill_sets;
  }

  // Handle the specific API response format (legacy support)
  if (
    Array.isArray(response.organizations) &&
    response.organizations.length > 0 &&
    !organization.organizationId
  ) {
    organization = mapOrganization(response.organizations[0]);
  }

  // Handle direct organization object
  if (response.id || response.name) {
    organization = mapOrganization(response);
  }

  // Handle nested response formats
  if (
    response.orgProfileData &&
    response.orgProfileData.CurrentOrganizationView
  ) {
    organization = mapOrganization(
      response.orgProfileData.CurrentOrganizationView,
    );
  }

  if (response.CurrentOrganizationView) {
    organization = mapOrganization(response.CurrentOrganizationView);
  }

  // Return the complete mapped response
  return {
    ...organization,
    ServiceLocations,
    OrgSkillsList,
  };
};
